import {
  type Configuration,
  PublicClientApplication,
  type RedirectRequest,
} from '@azure/msal-browser';

const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;
const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;

if (!clientId || !tenantId) {
  throw new Error(
    'VITE_ENTRA_CLIENT_ID and VITE_ENTRA_TENANT_ID must be set. Copy .env.local.example to .env.local.',
  );
}

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: `${window.location.origin}/auth/callback`,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'memory',
    // Brief redirect-flow state (PKCE verifier, nonce) lives in a temporary cookie that
    // MSAL clears after callback. Access tokens themselves stay in memory — XSS-resistant.
    storeAuthStateInCookie: true,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const apiScopes: string[] = [import.meta.env.VITE_API_SCOPE];

export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email', ...apiScopes],
};

await msalInstance.initialize();

// Process the redirect response BEFORE React renders. This ensures the account
// cache is populated before any TanStack Router beforeLoad runs.
try {
  const result = await msalInstance.handleRedirectPromise();
  console.log('[msal-init] handleRedirectPromise result:', result);
  if (result?.account) {
    msalInstance.setActiveAccount(result.account);
    console.log('[msal-init] active account set:', result.account.username);
  }
  console.log('[msal-init] accounts after init:', msalInstance.getAllAccounts().map(a => a.username));
} catch (err) {
  console.error('[msal-init] handleRedirectPromise threw:', err);
}
